const PRIORITY_LEVELS = {
  file: {
    0: 'DONT_DOWNLOAD',
    1: 'NORMAL',
    2: 'HIGH',
  },
  torrent: {
    0: 'DONT_DOWNLOAD',
    1: 'LOW',
    2: 'NORMAL',
    3: 'HIGH',
  },
};

export default PRIORITY_LEVELS;



// WEBPACK FOOTER //
// ./client/src/javascript/constants/PriorityLevels.js